import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-2" }, "Personendaten")
], -1)
const _hoisted_4 = { class: "col-12 col-lg-6" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-prename",
  class: "form-label"
}, "Vorname *", -1)
const _hoisted_7 = { class: "col-12 col-lg-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-surname",
  class: "form-label"
}, "Nachname *", -1)
const _hoisted_10 = { class: "col-12 col-lg-6" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-known-through",
  class: "form-label"
}, "Wie hast du von buggyFit erfahren? *", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "–", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-12 col-lg-6" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-park-wish",
  class: "form-label"
}, "Wähle deinen Wunschpark *", -1)
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-2" }, "Kontaktdaten")
], -1)
const _hoisted_20 = { class: "col-12 col-lg-6" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-phone-mobile",
  class: "form-label"
}, "Handynummer *", -1)
const _hoisted_23 = { class: "col-12 col-lg-6" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-phone-mobile-confirmation",
  class: "form-label"
}, "Handynummer Bestätigung *", -1)
const _hoisted_26 = { class: "row mt-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-2" }, "Zugangsdaten")
], -1)
const _hoisted_28 = { class: "col-12 col-lg-6" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-email",
  class: "form-label"
}, "E-Mail-Adresse *", -1)
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-region",
  class: "form-label"
}, "Standort", -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "–", -1)
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "col-12 col-lg-6" }
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-birthday",
  class: "form-label"
}, "Geburtsdatum (DD.MM.JJJJ) *", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  id: "register-input-birthday-description",
  class: "form-text text-danger"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(" Achtung: Dein Geburtsdatum wird dein Passwort sein! ")
], -1)
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-birthday-confirmation",
  class: "form-label"
}, "Geburtsdatum Bestätigung *", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  id: "register-input-birthday-confirmation-description",
  class: "form-text"
}, "Bitte gib dein Geburtsdatum erneut ein.", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, null, -1)
const _hoisted_44 = { class: "row mt-4" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "register-input-consent-newsletter"
}, "Ja, ich möchte den buggyFit Newsletter abonnieren.", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  id: "register-input-consent-newsletter-description",
  class: "form-text"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Schreib Dich in den Newsletter von deinen Gebiet ein und bekomme regelmäßig Neuigkeiten und vor allem besondere Angebote und Specials - garantiert kein Spam.")
], -1)
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "register-input-consent-terms"
}, [
  /*#__PURE__*/_createTextVNode("Ja, ich habe die "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.buggyfit.de/agb",
    target: "_blank",
    style: {"font-weight":"bold","color":"#cc3366"}
  }, "AGB"),
  /*#__PURE__*/_createTextVNode(" gelesen und akzeptiert.")
], -1)
const _hoisted_51 = { class: "mb-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "register-input-consent-privacy"
}, [
  /*#__PURE__*/_createTextVNode("Ja, ich habe die "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.buggyfit.de/datenschutz",
    target: "_blank",
    style: {"font-weight":"bold","color":"#cc3366"}
  }, "Datenschutzerklärung"),
  /*#__PURE__*/_createTextVNode(" gelesen und akzeptiert.")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "Registrieren", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoursePreview = _resolveComponent("CoursePreview")!
  const _component_FieldError = _resolveComponent("FieldError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.course)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CoursePreview, {
            course: _ctx.course,
            "appointment-preselect": _ctx.appointmentPreselect,
            onAppointmentSelected: _ctx.onAppointmentSelected,
            "validation-errors": _ctx.errors.appointment || []
          }, null, 8, ["course", "appointment-preselect", "onAppointmentSelected", "validation-errors"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      novalidate: "",
      class: ""
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.prename || false}]),
                id: "register-input-prename",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.prename) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.prename]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.prename || []
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.surname || false}]),
                id: "register-input-surname",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.surname) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.surname]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.surname || []
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", {'is-invalid': _ctx.errors.known_through || false}]),
                "aria-label": "Wie haben Sie von BuggyFit erfahren?",
                id: "register-input-known-through",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.known_through) = $event))
              }, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knownThroughValues, (value) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: value,
                    key: value
                  }, _toDisplayString(value), 9, _hoisted_14))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.form.known_through]
              ]),
              ((_ctx.form.known_through || '').toLowerCase() === 'sonstiges')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    class: _normalizeClass(["form-control mt-2", {'is-invalid': _ctx.errors.known_through || false}]),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.known_through_custom) = $event)),
                    placeholder: "Bitte eingeben"
                  }, null, 2)), [
                    [_vModelText, _ctx.form.known_through_custom]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.known_through || []
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.park_wish || false}]),
                id: "register-input-park-wish",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.park_wish) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.park_wish]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.park_wish || []
              }, null, 8, ["errors"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.phone_mobile || false}]),
                id: "register-input-phone-mobile",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.phone_mobile) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.phone_mobile]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.phone_mobile || []
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.phone_mobile_confirmation || false}]),
                id: "register-input-phone-mobile-confirmation",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.phone_mobile_confirmation) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.phone_mobile_confirmation]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.phone_mobile_confirmation || []
              }, null, 8, ["errors"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.email || false}]),
                id: "register-input-email",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.email) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.email]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.email || []
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", {'is-invalid': _ctx.errors.region || false}]),
                "aria-label": "Region",
                id: "register-input-region",
                disabled: _ctx.regionLocked,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.region) = $event))
              }, [
                _hoisted_34,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: region.id,
                    key: region.id
                  }, _toDisplayString(region.name), 9, _hoisted_35))
                }), 128))
              ], 10, _hoisted_33), [
                [_vModelSelect, _ctx.form.region]
              ]),
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.region || []
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.birthday || false}]),
                id: "register-input-birthday",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.birthday) = $event)),
                placeholder: "DD.MM.JJJJ"
              }, null, 2), [
                [_vModelText, _ctx.form.birthday]
              ]),
              _hoisted_39,
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.birthday || []
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "register-input-birthday-confirmation",
                "aria-describedby": "register-input-birthday-confirmation-description",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.birthday_confirmation) = $event)),
                placeholder: "DD.MM.JJJJ"
              }, null, 512), [
                [_vModelText, _ctx.form.birthday_confirmation]
              ]),
              _hoisted_42,
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.birthday_confirmation || []
              }, null, 8, ["errors"])
            ])
          ]),
          _hoisted_43
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.errors.consent_newsletter || false}]),
                id: "register-input-consent-newsletter",
                "aria-describedby": "register-input-consent-newsletter-description",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.consent_newsletter) = $event))
              }, null, 2), [
                [_vModelCheckbox, _ctx.form.consent_newsletter]
              ]),
              _hoisted_47,
              _hoisted_48,
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.consent_newsletter || []
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.errors.consent_terms || false}]),
                id: "register-input-consent-terms",
                "aria-describedby": "register-input-consent-terms-description",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.consent_terms) = $event))
              }, null, 2), [
                [_vModelCheckbox, _ctx.form.consent_terms]
              ]),
              _hoisted_50,
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.consent_terms || []
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.errors.consent_privacy || false}]),
                id: "register-input-consent-privacy",
                "aria-describedby": "register-input-consent-privacy-description",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.consent_privacy) = $event))
              }, null, 2), [
                [_vModelCheckbox, _ctx.form.consent_privacy]
              ]),
              _hoisted_52,
              _createVNode(_component_FieldError, {
                errors: _ctx.errors.consent_privacy || []
              }, null, 8, ["errors"])
            ]),
            _hoisted_53
          ])
        ])
      ])
    ], 32)
  ], 64))
}